module.exports = __webpack_public_path__ + "img/map-icon.63f7fd3a.svg";